import { InstitutionInterestView } from "@bitwarden/web-vault/app/models/view/institution/institution-interest.view";

export function _getAppliedInterest(
  rates: InstitutionInterestView[],
  amount: number,
): InstitutionInterestView {
  const sortedRates = rates.sort((a, b) => a.range - b.range);

  for (const rate of sortedRates) {
    if (amount <= rate.range) {
      return rate;
    }
  }
  return sortedRates.find((rate) => rate.range === -1);
}
